import React from "react";
import DatePicker from "react-datepicker";

import "../../../node_modules/react-datepicker/dist/react-datepicker.min.css"
import "../../css/stylesheets/inputs/customDatePickerWidth.css"

export const InputDate : React.FC<Props> = (props : Props) : JSX.Element => {

    const date : Date | null = props.value !== undefined ? props.value : null;
    const classRequired : string = props.isRequired ? "required" : "";
    const classCss: string = props.classCss ? props.classCss : "";

    return (
      <div className="input-container">
        { props.label ?
          <label className={classRequired}>
            <span>{props.label}</span>
          </label> : null
        }
        <div className="datepicker">
            <DatePicker
              locale={props.locale}
              calendarClassName="datepicker-styles"
              selected={date}
              onChange={(value)=>{props.onChange(value)}}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              dateFormat="dd/MM/yyyy"
              placeholderText='JJ/MM/AAAA'
              isClearable={true}
              className={classCss}
            >
            </DatePicker>
        </div>
      </div>
    )  

};


export const InputYear : React.FC<Props> = (props : Props) : JSX.Element => {

  const date : Date | null = props.value !== undefined ? props.value : null
  const classRequired : string = props.isRequired ? "required" : ""


  return (
    <div className="input-container">
      { props.label ?
        <label className={classRequired}>
          <span>{props.label}</span>
        </label> : null
      }
      <div className="datepicker">
          <DatePicker
              locale="fr"
              calendarClassName="datepicker-styles"
              selected={date}
              onChange={(value)=>{props.onChange(value)}}
              placeholderText='AAAA'
              showYearPicker
              dateFormat="yyyy"
              yearItemNumber={9}
          />
      </div>
    </div>
  )  

};

export const InputMonth : React.FC<Props> = (props : Props) : JSX.Element => {

  const date : Date | null = props.value !== undefined ? props.value : null
  const classRequired : string = props.isRequired ? "required" : ""
  
  return (
    <div className="input-container">
      { props.label ?
        <label className={classRequired}>
          <span>{props.label}</span>
        </label> : null
      }
      <div className="datepicker">
          <DatePicker
            locale="fr"
            selected={date}
            onChange={(value)=>{props.onChange(value)}}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            calendarClassName="datepicker-styles"
          />
      </div>
    </div>
  )  

};

interface Props {
    readonly label : string | undefined;
    readonly locale : string | undefined;
    readonly value : Date | null | undefined ;
    readonly onChange : CallableFunction;
    readonly isRequired : boolean | undefined;
    readonly classCss? : string | undefined ;
}